import { useCallback, useMemo, useState } from 'react';
import useSearchParamsConfig from './useSearchParamsConfig';
import _ from 'lodash';

export default function useOpportunityFilters(defaultSearchParams) {
  const filters = useMemo(
    () => ({
      opportunityAmountGreaterThanOrEqual: null,
      opportunityOwners: [],
      opportunityPractices: [],
      opportunityStages: [],
      opportunityStageCategories: [],
      opportunityTags: [],
      opportunityTypes: [],
    }),
    [],
  );

  const [defaultParams] = useState(defaultSearchParams);

  const searchParamsConfig = useSearchParamsConfig();

  const opportunitySearchParamsConfig = useMemo(
    () => ({
      opportunityAmountGreaterThanOrEqual: searchParamsConfig.opportunityAmountGreaterThanOrEqual,
      opportunityOwners: searchParamsConfig.opportunityOwners,
      opportunityPractices: searchParamsConfig.opportunityPractices,
      opportunityStages: searchParamsConfig.opportunityStages,
      opportunityStageCategories: searchParamsConfig.opportunityStageCategories,
      opportunityTags: searchParamsConfig.opportunityTags,
      opportunityTypes: searchParamsConfig.opportunityTypes,
      ...defaultParams,
    }),
    [searchParamsConfig, defaultParams],
  );

  const mapUrlSearchParams = useCallback((filters) => {
    return {
      opportunityAmountGreaterThanOrEqual: _.isNumber(filters?.opportunityAmountGreaterThanOrEqual)
        ? filters.opportunityAmountGreaterThanOrEqual
        : undefined,
      opportunityOwnerId: filters.opportunityOwners?.map((owner) => owner.id),
      opportunityPracticeId: filters.opportunityPractices?.map((practice) => practice.id),
      opportunityStageId: filters.opportunityStages.length ? filters.opportunityStages.map((stage) => stage.id) : [],
      opportunityStageCategoryId: filters.opportunityStageCategories?.map((status) => status.id),
      opportunityTagId: filters.opportunityTags.length ? filters.opportunityTags.map((tag) => tag.id) : [],
      opportunityTypeId: filters.opportunityTypes?.map((type) => type.id),
    };
  }, []);

  return useMemo(
    () => ({ filters, searchParamsConfig: opportunitySearchParamsConfig, mapUrlSearchParams }),
    [filters, opportunitySearchParamsConfig, mapUrlSearchParams],
  );
}
